// Telefonni ko'rsatish uchun yagona helper: "+998 XX XXX XX XX".
// '998901234567', '+998901234567' va '901234567' ni qabul qiladi; o'zbek raqami
// bo'lmasa (chet el va h.k.) asl qiymat o'zgarishsiz qaytariladi. Bo'sh -> ''.
export function formatPhone(value) {
  if (value == null || value === '') return '';
  const raw = String(value).trim();
  let digits = raw.replace(/\D/g, '');
  if (digits.length === 9) digits = `998${digits}`;
  if (digits.length !== 12 || !digits.startsWith('998')) return raw;
  return `+998 ${digits.slice(3, 5)} ${digits.slice(5, 8)} ${digits.slice(8, 10)} ${digits.slice(10, 12)}`;
}

// Telefon KIRITISH maydonlari uchun yagona helper (mobil Login bilan bir xil qoida).
// Raqam bo'lmagan belgilar olib tashlanadi; '998' bilan boshlansa va uzunligi >= 12 bo'lsa
// (yoki matn '+998' bilan boshlansa) prefiks kesiladi; ko'pi bilan 9 raqam qoladi.
// '+998945790002', '998 94 579-00-02', '945790002' → '945790002'.
export function phoneLocalDigits(value) {
  const raw = String(value == null ? '' : value).trim();
  let digits = raw.replace(/\D/g, '');
  if (digits.startsWith('998') && (digits.length >= 12 || raw.startsWith('+'))) digits = digits.slice(3);
  return digits.slice(0, 9);
}

// Maydonda ko'rsatiladigan niqob: '945790002' → '94 579 00 02' (to'liq bo'lmasa qisman).
export function formatLocalPhone(value) {
  const d = phoneLocalDigits(value);
  return [d.slice(0, 2), d.slice(2, 5), d.slice(5, 7), d.slice(7, 9)].filter(Boolean).join(' ');
}

// Backendga yuboriladigan kanonik format: '998XXXXXXXXX' (12 raqam). Yaroqsiz bo'lsa ''.
export function toApiPhone(value) {
  const d = phoneLocalDigits(value);
  return d.length === 9 ? `998${d}` : '';
}
